import { render, staticRenderFns } from "./MisionVision.vue?vue&type=template&id=64a7b678&scoped=true&"
import script from "./MisionVision.vue?vue&type=script&lang=js&"
export * from "./MisionVision.vue?vue&type=script&lang=js&"
import style0 from "./MisionVision.vue?vue&type=style&index=0&id=64a7b678&lang=sass&scoped=true&"
import style1 from "./MisionVision.vue?vue&type=style&index=1&id=64a7b678&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a7b678",
  null
  
)

export default component.exports